import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/customer', // 运营
  name: 'customer',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.customer',
    requiresAuth: true,
    icon: 'icon-user-group',
    order: 1,
  },
  children: [
    {
      path: 'customerManage', // The midline path complies with SEO specifications
      name: 'customerManage',
      component: () => import('@/views/operation/customer/index.vue'),
      meta: {
        locale: 'menu.customerManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default LIST;
